import { ElMessage } from "element-plus";
import { getUserInfo } from "@/utils/auth.js";
import { findApiPermission, hasPermission } from "@/utils/rbac.js";

const LOGIN_REQUIRED_CODE = "LOGIN_REQUIRED";
const LOGIN_EXPIRED_MESSAGE = "token已失效，请重新授权登录";
const PERMISSION_DENIED_MESSAGE = "当前角色无权执行该操作";
let installed = false;
let lastToastAt = 0;

function showLoginExpiredToast() {
  const now = Date.now();
  if (now - lastToastAt < 2000) {
    return;
  }

  lastToastAt = now;
  ElMessage.warning(LOGIN_EXPIRED_MESSAGE);
}

async function checkLoginRequired(response) {
  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    return;
  }

  try {
    const result = await response.clone().json();
    if (result && result.errcode === LOGIN_REQUIRED_CODE) {
      showLoginExpiredToast();
    }
  } catch (error) {
    // Ignore non-standard JSON responses so the original caller keeps its behavior.
  }
}

function getFetchUrl(args) {
  const input = args[0];
  if (typeof input === "string") {
    return input;
  }
  if (input && typeof input.url === "string") {
    return input.url;
  }
  return "";
}

function getFetchMethod(args) {
  const input = args[0];
  const options = args[1] || {};
  return (options.method || input?.method || "GET").toUpperCase();
}

function blockDeniedApi(args) {
  const url = getFetchUrl(args);
  const method = getFetchMethod(args);
  const apiPermission = findApiPermission(url, method);

  if (!apiPermission) {
    return false;
  }

  const allowed = hasPermission(getUserInfo(), apiPermission.permissionKey, apiPermission.action);
  if (allowed) {
    return false;
  }

  ElMessage.warning(PERMISSION_DENIED_MESSAGE);
  return true;
}

export function installAuthFetchInterceptor() {
  if (installed || typeof window === "undefined" || !window.fetch) {
    return;
  }

  installed = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    if (blockDeniedApi(args)) {
      throw new Error(PERMISSION_DENIED_MESSAGE);
    }

    const response = await originalFetch(...args);
    checkLoginRequired(response);
    return response;
  };
}
